<template>
  <Voucher :amount="amount" class="valid-voucher">
    <!-- <template v-slot:footer>
      <RemainingDay :remainingTime="remainingTime" />
    </template> -->
  </Voucher>
</template>

<script>
import moment from 'moment';
import Voucher from './Voucher.vue';
import RemainingDay from './RemainingDay.vue';

export default {
  name: 'ValidVoucher',
  components: {
    Voucher,
    RemainingDay
  },
  props: ['expireDate', 'amount'],
  computed: {
    remainingTime() {
      const startDay = moment(Date.now());
      const endDate = moment(this.expireDate);

      if (endDate.diff(startDay, 'hours') <= 0) return -1;
      else if (endDate.diff(startDay, 'hours') > 0 && endDate.diff(startDay, 'hours') < 24) return 1;
      else return endDate.diff(startDay, 'days');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/components/referFriends/referrals/validVoucher.scss';
</style>
